module.exports = {
	name: 'AudienceTrackerApi',
	provides: 'trackerApi',
	main: 'audience_tracker_api.js',
	dependencies: {
		/** @type Logger */
		logger: true,

		/** @type jQuery */
		jQuery: true
	}
};
